import { ValueOf } from '@zorro/types';
import { Center, brand } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';
import classNames from './Icon.module.scss';

type Props = SVGIconProps & {
  flagColor?: ValueOf<typeof brand> | 'transparent';
  withDot?: boolean;
};

export const FlagIcon = ({
  style,
  grow,
  withDot = false,
  flagColor = '#FFC214',
}: Props) => {
  if (withDot) {
    return (
      <Center style={style} classNames={classNames} data-grow={grow}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5 4.5H4V12H15.5L12 8L14.5 4.5Z"
            fill={flagColor === 'transparent' ? 'transparent' : '#FFBBAF'}
          />
          <path
            d="M4.16675 11.667H15.8334L12.0834 7.91699L15.8334 4.16699H4.16675V11.667Z"
            fill={flagColor}
            stroke={flagColor === 'transparent' ? 'currentColor' : flagColor}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4 4V17.5"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <g transform="translate(10.5 10.5)">
            <path
              d="M6 3C6 4.65945 4.65354 6 3 6C1.34646 6 0 4.65354 0 3C0 1.34646 1.34646 0 3 0C4.65354 0 6 1.34646 6 3Z"
              fill="#275853"
            />
            <path
              d="M3.00037 3.30906C2.83196 3.30906 2.69071 3.17325 2.69071 2.9994V1.52172C2.69071 1.3533 2.82653 1.21205 3.00037 1.21205C3.17422 1.21205 3.31003 1.34787 3.31003 1.52172V2.9994C3.31003 3.16781 3.17422 3.30906 3.00037 3.30906Z"
              fill="#C9F3E6"
            />
            <path
              d="M3.18528 4.60195C3.11465 4.64541 3.0386 4.67257 2.95711 4.67257C2.84845 4.67257 2.7398 4.62911 2.66374 4.55305C2.58769 4.477 2.54422 4.36834 2.54422 4.25969C2.54422 4.1782 2.56595 4.09671 2.61485 4.03152C2.65831 3.96089 2.7235 3.912 2.79956 3.8794C2.87562 3.84681 2.95711 3.84137 3.0386 3.85767C3.12009 3.87397 3.19071 3.912 3.25047 3.97176C3.31023 4.03152 3.34826 4.10214 3.36456 4.18363C3.38085 4.26512 3.36999 4.34661 3.34283 4.42267C3.31023 4.49873 3.2559 4.56392 3.19071 4.60738L3.18528 4.60195Z"
              fill="#C9F3E6"
            />
          </g>
        </svg>
      </Center>
    );
  }

  return (
    <Center style={style} classNames={classNames} data-grow={grow}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.5 4.5H4V12H15.5L12 8L14.5 4.5Z"
          fill={flagColor === 'transparent' ? 'transparent' : '#FFBBAF'}
        />
        <path
          d="M4.16675 11.667H15.8334L12.0834 7.91699L15.8334 4.16699H4.16675V11.667Z"
          fill={flagColor}
          stroke={flagColor === 'transparent' ? 'currentColor' : flagColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 4V17.5"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </Center>
  );
};
